"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PortIndex = exports.AnomalityType = void 0;

var object_type_1 = require("./lwm2m/object_type");

var AnomalityType;

(function (AnomalityType) {
  AnomalityType[AnomalityType["Sag"] = 0] = "Sag";
  AnomalityType[AnomalityType["Swell"] = 1] = "Swell";
  AnomalityType[AnomalityType["Outage"] = 2] = "Outage";
  AnomalityType[AnomalityType["FloatingNeutral"] = 1000] = "FloatingNeutral";
})(AnomalityType = exports.AnomalityType || (exports.AnomalityType = {}));
/** A Lightweight M2M URI decoder */


var PortIndex =
/** @class */
function () {
  function PortIndex(index) {
    this.index = index;
    this.parts = this.index.split("/");
    this.object = "";
    this.objectInstance = "";
    this.resource = "";
    this.instance = "";

    if (this.parts.length > 2) {
      this.object = this.parts[1];
      this.objectInstance = this.parts[2];
      this.resource = this.parts[3];

      if (this.parts.length > 3) {
        this.instance = this.parts[4];
      }
    }
  }

  PortIndex.prototype.phase = function () {
    if (this.object === "10243" || this.object === "7050") {
      // phase meter or anomality
      return parseInt(this.objectInstance[this.objectInstance.length - 1]);
    }

    throw Error("The port in question is not a phase meter");
  };
  /** This is a helper function to calculate the proper semantic meaning of the objectInstance, i.e. split it between address and phase if needed */


  PortIndex.prototype.objectAddress = function () {
    if (this.objectType() === object_type_1.ObjectType.ElectricityPhase) {
      if (this.objectInstance.length > 1) {
        // old style
        return parseInt(this.objectInstance.substr(0, this.objectInstance.length - 1));
      } else {
        // prefixed style
        return 0;
      }
    }

    return parseInt(this.objectInstance);
  };

  PortIndex.prototype.anomalityType = function () {
    if (this.object === "7050") {
      //  Anomality
      if (this.objectInstance.length === 4) {
        return parseInt(this.objectInstance);
      }

      if (this.objectInstance.length === 1) {
        if (this.objectInstance === "0") {
          return AnomalityType.Outage;
        }

        return AnomalityType.Sag;
      }

      return parseInt(this.objectInstance[0]);
    }

    throw Error("The port in question is not an anomality port");
  };
  /** Tries to find an appropriate `ObjectType` for the relevant object string */


  PortIndex.prototype.objectType = function () {
    return object_type_1.stringToObjectType(this.object);
  };
  /** Calculates the partial index of a the meter which this port index should come from */


  PortIndex.prototype.meterIndex = function () {
    var ret = "/";

    if (this.objectType() === object_type_1.ObjectType.ElectricityPhase) {
      return ret + object_type_1.ObjectType.ElectricityThreePhase + "/" + this.objectAddress();
    }

    if (this.objectType() === object_type_1.ObjectType.HeatingCooling) {
      return ret + object_type_1.ObjectType.HeatingCooling + "/0"; // kinda hack
    }

    if (this.objectType() === object_type_1.ObjectType.HeatingCooling) {
      return ret + object_type_1.ObjectType.HeatingCooling + "/0"; // kinda hack
    }

    if (this.objectType() === object_type_1.ObjectType.MbusOther) {
      if (this.objectAddress() === 3) {
        return ret + this.object + "/2";
      }
    }

    if (this.objectType() === object_type_1.ObjectType.Pressure) {
      return ret + object_type_1.ObjectType.Pressure + "/0"; // kinda hack
    }

    return ret + this.object + "/" + this.objectAddress();
  };

  PortIndex.prototype.equal = function (p) {
    return this.index === p.index && this.object === p.object && this.resource === p.resource && this.objectInstance === p.objectInstance && this.instance === p.instance;
  };
  /*
  compare {
    if (a is less than b by some ordering criterion) {
      return -1;
    }
    if (a is greater than b by the ordering criterion) {
      return 1;
    }
    // a must be equal to b
    return 0;
  }
  */

  /** Compare is a compare function used for sorting port indices. The sorting is based on an
   * designer order logic and does only follow "reasonability" and no numeric or lexical order.
   * This returns a smaller number for indices which should be place before it.
   *
   * The sorting logic first orders objects such that more significant ones are first, however
   * it is up to the user to decide what measurement is most important so we only ensure that
   * measurement objects are first, followed by non-measurement, then by metadata and finally
   * various debugging and system internal ports.
   *
   * We then sort by object instance such that the lower number is ordered first, by the logic
   * that the installer has numbered the submeters reasonably
   *
   * We then sort by resource type in a designed order, specific to the measured quantity. This
   * is often cumulative registers first, then the most calculated registers (e.g. Energy, Power, normalized gas)
   * followed by more natural registers (e.g. current, voltage, temperature) followed by "uninteresting"
   * resources, e.g. battery voltage, frequency, set points
   * */


  PortIndex.prototype.compare = function (b) {
    if (this.object !== b.object) {
      // larger number first
      // void cases
      if (this.object == null && b.object == null) {
        return 0;
      }

      if (this.object != null && b.object == null) {
        return -1;
      }

      if (this.object == null && b.object != null) {
        return 1;
      }

      if (this.object.length === 0 && b.object.length === 0) {
        return 0;
      }

      if (this.object.length > 0 && b.object.length === 0) {
        return -1;
      }

      if (this.object.length === 0 && b.object.length > 0) {
        return 1;
      } // parsable as numbers


      if (!isFinite(parseInt(this.object)) && !isFinite(parseInt(b.object))) {
        return 0;
      }

      if (isFinite(parseInt(this.object)) && !isFinite(parseInt(b.object))) {
        return -1;
      }

      if (!isFinite(parseInt(this.object)) && isFinite(parseInt(b.object))) {
        return 1;
      } // the actual application case


      return object_type_1.objectTypeToOrderPriority(this.objectType()) - object_type_1.objectTypeToOrderPriority(b.objectType()) > 0 ? 1 : -1;
    }

    if (this.objectAddress() !== b.objectAddress()) {
      // smaller number first
      if (!isFinite(this.objectAddress()) && !isFinite(b.objectAddress())) {
        return 0;
      }

      if (isFinite(this.objectAddress()) && !isFinite(b.objectAddress())) {
        return -1;
      }

      if (!isFinite(this.objectAddress()) && isFinite(b.objectAddress())) {
        return 1;
      }

      return this.objectAddress() - b.objectAddress() > 0 ? 1 : -1;
    }

    if (this.resource !== b.resource) {
      if (this.resource == null && b.resource == null) {
        return 0;
      }

      if (this.resource != null && b.resource == null) {
        return -1;
      }

      if (this.resource == null && b.resource != null) {
        return 1;
      }

      if (this.resource.length === 0 && b.resource.length === 0) {
        return 0;
      }

      if (this.resource.length > 0 && b.resource.length === 0) {
        return -1;
      }

      if (this.resource.length === 0 && b.resource.length > 0) {
        return 1;
      } // parsable as numbers


      if (!isFinite(parseInt(this.resource)) && !isFinite(parseInt(b.resource))) {
        return 0;
      }

      if (isFinite(parseInt(this.resource)) && !isFinite(parseInt(b.resource))) {
        return -1;
      }

      if (!isFinite(parseInt(this.resource)) && isFinite(parseInt(b.resource))) {
        return 1;
      }

      return this.resourceObjectPriority(this.objectType(), this.resource) - this.resourceObjectPriority(b.objectType(), b.resource) > 0 ? 1 : -1;
    }

    try {
      if (this.phase() !== b.phase()) {
        return this.phase() - b.phase() > 0 ? 1 : -1;
      }
    } catch (error) {} // ignore


    if (this.instance !== b.instance) {
      if (this.instance == null) {
        return 1;
      }

      if (b.instance == null) {
        return -1;
      } // if (this.instance.length===0 && b.instance.length===0) { return 0; } // cant both be empty and not be the same, dead code


      if (this.instance.length > 0 && b.instance.length === 0) {
        return -1;
      }

      if (this.instance.length === 0 && b.instance.length > 0) {
        return 1;
      } // parsable as numbers


      if (!isFinite(parseInt(this.instance)) && !isFinite(parseInt(b.instance))) {
        return 0;
      }

      if (isFinite(parseInt(this.instance)) && !isFinite(parseInt(b.instance))) {
        return -1;
      }

      if (!isFinite(parseInt(this.instance)) && isFinite(parseInt(b.instance))) {
        return 1;
      }

      return parseInt(this.instance) - parseInt(b.instance) > 0 ? 1 : -1;
    }

    return 0;
  };

  PortIndex.prototype.resourceObjectPriority = function (object, resource) {
    if (object === object_type_1.ObjectType.ElectricityPhase || object === object_type_1.ObjectType.ElectricityThreePhase || object === object_type_1.ObjectType.ElectricVehicleChargingStation) {
      // electricity
      // cumulative ports
      if (resource === "18") {
        return 1;
      }

      if (resource === "28") {
        return 2;
      }

      if (resource === "38") {
        return 3;
      }

      if (resource === "48") {
        return 4;
      } // active power


      if (resource === "167") {
        return 5;
      }

      if (resource === "163") {
        return 6;
      }

      if (resource === "35") {
        return 8;
      } // reactive


      if (resource === "37") {
        return 9;
      }

      if (resource === "47") {
        return 10;
      }

      if (resource === "55") {
        return 11;
      }

      if (resource === "97") {
        return 12;
      } // apparent


      if (resource === "115") {
        return 13;
      } // current


      if (resource === "117") {
        return 14;
      }

      if (resource === "135") {
        return 15;
      }

      if (resource === "113") {
        return 16;
      }

      if (resource === "116") {
        return 17;
      } // voltage


      if (resource === "127") {
        return 18;
      }

      if (resource === "145") {
        return 19;
      }

      if (resource === "123") {
        return 20;
      }

      if (resource === "126") {
        return 21;
      } // freq


      if (resource === "147") {
        return 22;
      }

      if (resource === "165") {
        return 23;
      } // pf


      if (resource === "137") {
        return 24;
      }

      if (resource === "155") {
        return 25;
      }

      if (resource === "133") {
        return 26;
      }

      if (resource === "136") {
        return 27;
      }

      if (resource === "29607") {
        return 30;
      }
    }

    if (object === object_type_1.ObjectType.PowerMeasurement) {
      if (resource === "5805") {
        return 1;
      }

      if (resource === "5815") {
        return 2;
      }

      if (resource === "5800") {
        return 3;
      }

      if (resource === "5810") {
        return 4;
      }

      if (resource === "5820") {
        return 5;
      }
    } // heating (10257)


    if (object === object_type_1.ObjectType.HeatingCooling || object === object_type_1.ObjectType.HeatingCoolingTypo) {
      if (resource === "5805") {
        return 1;
      } // energy


      if (resource === "5800") {
        return 2;
      } // power


      if (resource === "19") {
        return 3;
      } // volume


      if (resource === "17") {
        return 4;
      } // flow


      if (resource === "12") {
        return 5;
      } // flow temp


      if (resource === "13") {
        return 6;
      } // return temp


      if (resource === "14") {
        return 7;
      } // temp?


      if (resource === "8000") {
        return 8;
      } // external temp

    } // heating (10261)


    if (object === object_type_1.ObjectType.Water) {
      if (resource === "19") {
        return 3;
      } // volume


      if (resource === "17") {
        return 4;
      } // flow


      if (resource === "12") {
        return 5;
      } // flow temp


      if (resource === "13") {
        return 6;
      } // return temp

    } // heating (7030)


    if (object === object_type_1.ObjectType.HeatingCoolingLegacy) {
      if (resource === "5805") {
        return 1;
      } // energy


      if (resource === "5800") {
        return 2;
      } // power


      if (resource === "7035") {
        return 3;
      } // volume


      if (resource === "7034") {
        return 4;
      } // flow


      if (resource === "7031") {
        return 5;
      } // temp


      if (resource === "7033") {
        return 6;
      } // temp diff

    }

    if (object === object_type_1.ObjectType.Fan) {
      if (resource === "11") {
        return 1;
      } // actual speed


      if (resource === "26") {
        return 2;
      } // current power


      if (resource === "31") {
        return 3;
      } // torque


      if (resource === "14") {
        return 4;
      } // dc-link voltage


      if (resource === "15") {
        return 5;
      } // dc-link current


      if (resource === "21") {
        return 6;
      } // current set value


      if (resource === "17") {
        return 7;
      } // motor temp


      if (resource === "18") {
        return 8;
      } // Electronics temp


      if (resource === "16") {
        return 9;
      } // module temp


      if (resource === "4") {
        return 10;
      } // temp


      return 11 + parseInt(resource);
    }

    return 1000 + parseInt(resource);
  };

  return PortIndex;
}();

exports.PortIndex = PortIndex;